import type * as React from 'react';
import { Link } from '@tanstack/react-router';
import { hasPermission, useSession } from '@cguard/auth';
import { LockKeyhole } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function AdminGuard({ children }: { children: React.ReactNode }): React.JSX.Element {
  const { t } = useTranslation('video');
  const session = useSession();
  if (hasPermission(session, 'cameras.manage')) {
    return <>{children}</>;
  }
  return (
    <div className="admin-denied">
      <LockKeyhole aria-hidden size={26} />
      <h1>{t('admin.restricted')}</h1>
      <p>{t('admin.denied.body')}</p>
      <Link to="/live" className="secondary-button">
        {t('admin.denied.returnToLive')}
      </Link>
    </div>
  );
}
